/* eslint-disable max-len */
import React from 'react';
import Store from '../shared/state/Store';
import UiReducer from '../shared/state/UiReducer';
import InputConfirmationDialog from '../shared/InputConfirmationDialog';
import Utils from '../shared/Utils';

export default ({ primaryCallback }) => {
  const [globalState, dispatch] = Store.useStore();
  const uiKeyDialogOpen = UiReducer.Keys.GlobalEndUserAssignmentDialogOpen;

  const hide = () => {
    dispatch(UiReducer.setGenericUiAttribute(uiKeyDialogOpen, false));
  };

  if (!UiReducer.getGenericUiAttribute(globalState, UiReducer.Keys.GlobalEndUserAssignmentDialogOpen)) {
    return <></>;
  }

  const accountInfo = UiReducer.getGenericUiAttribute(globalState, UiReducer.Keys.AccountInfo);
  const subscriptionAccount = accountInfo?.primaryAccount;
  const globalEndUsers = subscriptionAccount?.subscription?.globalEndUsers || [];
  const maxUsersTotal = subscriptionAccount?.subscription?.maxUsersTotal || 0;
  const totalEndUsers = subscriptionAccount?.subscription?.totalEndUsers || 0;
  const globalEndUsersLimit = maxUsersTotal - totalEndUsers;
  const maxLimitText = (maxUsersTotal > 0 && globalEndUsersLimit > 0) ? `up to [${globalEndUsersLimit}]` : '[0]';

  return (
    <div style={{
      position: 'fixed',
      left: '-9999px',
      width: '0px',
      height: '0px',
    }}
    >
      <InputConfirmationDialog
        uiElementId={uiKeyDialogOpen}
        title="Assign Global End-Users"
        text={`Enter ${maxLimitText} emails one per line; or empty the box to clear assignments completely`}
        inputPlaceholder="Enter emails"
        initialValue={globalEndUsers.join('\n')}
        primaryButtonText="Assign"
        multiline
        rows={10}

        validateValue={(val) => {
          const value = `${val}`.trim().toLowerCase();
          if (value === '') {
            // If value is empty, we are un-assigning all emails
            return '';
          }

          const emails = value.split('\n').filter((row) => row.trim() !== '').map((emailRaw) => {
            const email = Utils.emailPreformat(emailRaw);
            if (!email.match(/\S+@\S+\.\S+/) || (email.match(/@/g) || []).length !== 1) {
              throw new Error(`Invalid email format: ${email}`);
            }
            return email;
          });

          const emailsUnique = [...new Set(emails)];

          if (globalEndUsersLimit > 0 && emailsUnique.length > globalEndUsersLimit) {
            throw new Error(`Maximum [${globalEndUsersLimit}] global end users allowed at this time`);
          }
          return emailsUnique.join('\n');
        }}

        primaryCallback={primaryCallback}
        secondaryCallback={() => { hide(); }}
      />
    </div>
  );
};
